<template>
  <div data-test-id="context-menu" class="contextmenu" :class="{ sub: depth > 0 }" :style="{ ...positions, transform }">
    <template v-for="(item, i) in localData">
      <div
        v-if="!item.hide"
        :key="item.id"
        :data-test-id="item.testId"
        class="contextmenu__item"
        :class="{ 'contextmenu__item-active': index === i }"
        @click="callFunction($event, item, i)"
      >
        <!-- <v-icon class="contextmenu__item-icon"> {{ item.icon }} </v-icon> -->
        <span class="contextmenu__item-icon" :class="`${item.icon}`"></span>
        <div class="contextmenu__item-text">{{ item.title }}</div>
        <div class="contextmenu__item-shortcut">
          <!-- <v-icon v-if="item.shortcutType === 'icon'" color="rgb(85, 85, 85)" class="contextmenu__item-icon">{{ item.shortcut }}</v-icon> -->
          <span v-if="item.shortcutType === 'icon'" class="contextmenu__item-chevronicon" :class="item.shortcut"></span>
          <span v-else class="contextmenu__item-shortcut-text" v-html="item.shortcut"></span>
        </div>
        <sub-context
          v-if="activeSubContextId === item.id"
          :data="item.children"
          :depth="depth + 1"
          @hide-subcontext-menu="activeSubContextId = null"
        ></sub-context>
      </div>
    </template>
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";

export default {
  name: "SubContext",
  props: ["data", "depth"],
  emits: ["hide-subcontext-menu"],
  data() {
    return {
      index: -1,
      activeSubContextId: null,
      transform: "unset",
    };
  },
  computed: {
    positions() {
      return {
        top: this.depth === 0 ? `${this.activeContextMenu.y}px` : 0,
        left: this.depth === 0 ? `${this.activeContextMenu.x}px` : "unset",
      };
    },
    localData() {
      return this.data.filter((item) => !item.hide);
    },
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
  },
  mounted() {
    hotkeys("up", HotkeyScopes.SidebarContextMenu, this.upArrow);
    hotkeys("down", HotkeyScopes.SidebarContextMenu, this.downArrow);
    hotkeys("right", HotkeyScopes.SidebarContextMenu, this.rightArrow);
    hotkeys("enter", HotkeyScopes.SidebarContextMenu, this.enter);
    hotkeys("left,esc", HotkeyScopes.SidebarContextMenu, this.leftArrow);
    this.setTransform();
  },
  beforeUnmount() {
    hotkeys.unbind("up", HotkeyScopes.SidebarContextMenu, this.upArrow);
    hotkeys.unbind("down", HotkeyScopes.SidebarContextMenu, this.downArrow);
    hotkeys.unbind("right", HotkeyScopes.SidebarContextMenu, this.rightArrow);
    hotkeys.unbind("enter", HotkeyScopes.SidebarContextMenu, this.enter);
    hotkeys.unbind("left,esc", HotkeyScopes.SidebarContextMenu, this.leftArrow);
  },
  methods: {
    callFunction(event, item, index) {
      if (index) this.index = index;
      // hide context menu if the active item is clicked on again
      if (this.activeSubContextId === item.id) return (this.activeSubContextId = null);

      if (item?.children?.length > 0) {
        return (this.activeSubContextId = item.id);
      }
      item.func && item.func();
    },
    enter(event, handler) {
      event.preventDefault();
      if (this.index < 0) return;
      const item = this.localData[this.index];
      this.callFunction(event, item);
    },
    upArrow(event, handler) {
      if (this.activeSubContextId) return;

      event.preventDefault();
      this.index = this.index <= 0 ? this.localData.length - 1 : (this.index - 1) % this.localData.length;
    },
    downArrow(event, handler) {
      if (this.activeSubContextId) return;

      event.preventDefault();
      this.index = (this.index + 1) % this.localData.length;
    },
    rightArrow(event, handler) {
      if (this.localData[this.index]?.children?.length > 0) {
        event.preventDefault();
        return (this.activeSubContextId = this.localData[this.index].id);
      }
    },
    leftArrow(event, handler) {
      if (this.activeSubContextId) return;

      event.preventDefault();
      this.$emit("hide-subcontext-menu");
    },
    setTransform() {
      let translateX = this.depth > 0 ? "100%" : "0";
      translateX = this.$el?.getBoundingClientRect().right > window.innerWidth ? "-100%" : translateX;
      const translateY = this.$el?.getBoundingClientRect().bottom > window.innerHeight ? "-100%" : "0";
      this.transform = `translate(${translateX},${translateY})`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";

.contextmenu {
  width: 14rem;
  background: white;
  position: fixed;
  transform: translate(40%, -5%);
  z-index: 1000;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24);
  &__item {
    font-family: "FiraSans-Regular", "Fira Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #555;
    text-rendering: optimizeLegibility;
    position: relative;
    display: flex;
    gap: 0.4rem;
    align-items: center;
    padding: 0.5rem 0.4rem;
    height: 40px;
    cursor: pointer;
    border-bottom: 2px solid rgb(242, 242, 242);
    &-icon {
      font-size: 18px;
      margin-right: 5px;
      margin-left: 5px;
    }
    &-chevronicon {
      font-size: 18px;
    }
    &-text {
      flex-grow: 1;
      text-align: left;
    }
    &:not(&-active)&:hover {
      background-color: @kk-color-light-blue;
      border-bottom: 2px solid @kk-color-light-blue;
    }
    &-active {
      background-color: @kk-color-primary-blue;
      border-bottom: 2px solid @kk-color-primary-blue;
      color: #fff;
    }
    &-shortcut {
      color: rgb(170, 170, 170);
      display: flex;
      align-items: center;
      &-text {
        padding-right: 8px;
      }
    }
    &-active > &-shortcut {
      color: #fff;
    }
  }
}
.sub {
  position: absolute;
  right: 0;
  top: 0;
  width: 17rem;
  background: white;
  z-index: 1000;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24);
  border-radius: 4px;
}
</style>
